
export default function Footer() {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-6xl mx-auto px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div>
            <div className="flex items-center space-x-3 mb-4">
              <div className="w-8 h-8 flex items-center justify-center">
                <i className="ri-cup-fill text-xl text-amber-400"></i>
              </div>
              <h3 className="text-xl font-bold" style={{ fontFamily: '"Pacifico", serif' }}>
                馬的咖啡
              </h3>
            </div>
            <p className="text-gray-300 leading-relaxed">
              用心種植，用愛烘焙<br />
              與山為家的自然咖啡味道
            </p>
          </div>
          
          <div>
            <h4 className="text-lg font-semibold mb-4">聯絡資訊</h4>
            <div className="space-y-2 text-gray-300">
              <div className="flex items-center space-x-2">
                <i className="ri-map-pin-line w-4 h-4 flex items-center justify-center"></i>
                <span>南投縣仁愛鄉中正村平等巷95號馬的咖啡</span>
              </div>
              <div className="flex items-center space-x-2">
                <i className="ri-phone-line w-4 h-4 flex items-center justify-center"></i>
                <span>0923-337087</span>
              </div>
              <div className="flex items-center space-x-2">
                <i className="ri-line-fill w-4 h-4 flex items-center justify-center"></i>
                <span>Line ID: 6808051979</span>
              </div>
              <div className="flex items-center space-x-2">
                <i className="ri-building-line w-4 h-4 flex items-center justify-center"></i>
                <span>統一編號：88750029</span>
              </div>
            </div>
          </div>
          
          <div>
            <h4 className="text-lg font-semibold mb-4">關注我們</h4>
            <div className="flex space-x-4">
              <div 
                className="w-10 h-10 bg-amber-600 rounded-full flex items-center justify-center cursor-pointer hover:bg-amber-700 transition-colors"
                onClick={() => window.open('https://www.facebook.com/profile.php?id=61566397156498', '_blank')}
              >
                <i className="ri-facebook-fill text-white"></i>
              </div>
              <div className="w-10 h-10 bg-amber-600 rounded-full flex items-center justify-center cursor-pointer hover:bg-amber-700 transition-colors">
                <i className="ri-instagram-line text-white"></i>
              </div>
              <div 
                className="w-10 h-10 bg-red-600 rounded-full flex items-center justify-center cursor-pointer hover:bg-red-700 transition-colors"
                onClick={() => window.open('https://www.youtube.com/@馬的咖啡', '_blank')}
              >
                <i className="ri-youtube-fill text-white"></i>
              </div>
            </div>
          </div>
        </div>
        
        <div className="border-t border-gray-700 mt-8 pt-8 text-center text-gray-400">
          <p>&copy; 2024 馬的咖啡-故事館. All rights reserved. | 
            <a href="https://readdy.ai/?origin=logo" className="text-amber-400 hover:text-amber-300 ml-1 cursor-pointer">
              Website Builder
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}
